import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Blue_Outline_Btn from "../../../common-components/common-btn/blue_outline_btn/Blue_Outline_Btn";
import Red_Outline_Btn from "../../../common-components/common-btn/red_outline_btn/Red_Outline_Btn";
import Reschedule_Appointment_Modal from "../../../common-components/common-modals/reschedule_appointment_modal/Reschedule_Appointment_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  cancleAppointment,
  getAppointments,
} from "../../../../features/appointment_form/formSlice";
import { logDOM } from "@testing-library/react";
import { formatDate } from "../../../../utils/common";
import { AiOutlineCalendar } from "react-icons/ai";
const appointments1 = [
  {
    name: "Prathamesh Raut",
    date: "25-06-2025",
    reason: "Eye Test",
    time: "10:30 AM",
    status: "Pending",
    img: "/assets/images/patient1.png",
  },
  {
    name: "Abhishek Shinde",
    date: "20-06-2025",
    reason: "Lenses",
    time: "4:40 PM",
    status: "Cancelled",
    img: "/assets/images/patient2.png",
  },
  {
    name: "Pratik Jadhav",
    date: "18-06-2025",
    reason: "Eye Test",
    time: "6:10 PM",
    status: "Confirmed",
    img: "/assets/images/patient3.png",
  },
];

const Appointments = () => {
  const [showModal, setShowModal] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [id, setId] = useState(false);

  const appointments = useSelector(
    (state) => state.appointmentForm.appointments
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAppointments());
  }, [dispatch]);


  const handleDelete = async (id) => {

    await dispatch(cancleAppointment({ id }));
    await dispatch(getAppointments());
  };

  return (
    <div className="common_table_container theme_bg">
      <div className="table-responsive">
        {appointments?.data?.length > 0 ? (
          <table className="common_table table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Contact Number</th>
                <th>Date</th>
                <th>Reason</th>
                <th>Time</th>
                {/* <th>Status</th> */}
              </tr>
            </thead>
            <tbody>
              {appointments.data.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <span className="bold_text">
                      {item?.name + " " + item?.last_name}
                    </span>
                  </td>
                  <td>{item.contact_no}</td>
                  <td>{formatDate(item.date_of_birth)}</td>
                  <td className="address_col">{item.Appointment_Reason?.name}</td>
                  <td>{item.time}</td>
                  {/* <td>{item.Appointment_Status?.name}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="empty-state text-center my-5">
            <AiOutlineCalendar
              size={80}
              color="#888"
              style={{ marginBottom: "20px" }}
            />
            <h5>No appointments found</h5>
            <p>All your scheduled appointments will appear here.</p>
          </div>
        )}
      </div>

      <Reschedule_Appointment_Modal
        id={id}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </div>
  );
};

export default Appointments;
